<template>
  <v-container grid-list-md>
    <v-layout wrap>
      <v-flex xs12 style="margin-top: 20px">
        <p v-if="$vuetify.breakpoint.xs" :class="$vuetify.breakpoint.smAndDown ? 'h2' : 'h1'">Reservas</p>
      </v-flex>

      <v-flex xs12 class="text-center" style="margin-top: 20px; padding: 0px">
        <p :class="$vuetify.breakpoint.smAndDown ? 'p16' : 'p20'">Escolha a forma que preferir para reservar sua estadia:</p>
      </v-flex>

      <v-flex xs12 class="text-center" style="margin-top: 20px">
        <p :class="$vuetify.breakpoint.smAndDown ? 'h4' : 'h3'">Cabana Gracillis</p>
      </v-flex>

      <v-row align="center" justify="center" class="fill-height">
        <v-col cols="auto">
          <a :href="urlPrivado">
            <img src="logo.png" :style="`width: ${$vuetify.breakpoint.xs ? '70px' : '120px'}`" />
          </a>
        </v-col>

        <v-col cols="auto">
          <a href="https://airbnb.com/h/gracillis-espacomossoo" target="_blank">
            <img src="hospedagem/airbnb.png" :style="`width: ${$vuetify.breakpoint.xs ? '70px' : '120px'}`" />
          </a>
        </v-col>

        <v-col cols="auto">
          <script
            type="application/javascript"
            async
            src="https://badge.hotelstatic.com/embed.js"
            data-url="https://www.booking.com/hotel/br/cabana-gracillis.html"
            :data-size="$vuetify.breakpoint.xs ? 32 : 50"
            data-position="inline"
            data-clickable="true"
          ></script>
        </v-col>
      </v-row>

      <v-flex xs12 class="text-center" style="margin-top: 30px">
        <p :class="$vuetify.breakpoint.smAndDown ? 'h4' : 'h3'">Chalé Vittata</p>
      </v-flex>

      <v-row align="center" justify="center" class="fill-height">
        <v-col cols="auto">
          <a :href="urlPrivado">
            <img src="logo.png" :style="`width: ${$vuetify.breakpoint.xs ? '70px' : '120px'}`" />
          </a>
        </v-col>

        <v-col cols="auto">
          <a href="https://airbnb.com/h/chalevittata-espacomossoo" target="_blank" rel="noopener noreferrer">
            <img src="hospedagem/airbnb.png" :style="`width: ${$vuetify.breakpoint.xs ? '70px' : '120px'}`" />
          </a>
        </v-col>

        <v-col cols="auto">
          <a href="https://www.booking.com/hotel/br/chale-vittata.pt-br.html" target="_blank" rel="noopener noreferrer">
            <img src="hospedagem/booking.svg" alt="Booking.com" :style="`width: ${$vuetify.breakpoint.xs ? '90px' : '150px'}`" />
          </a>
        </v-col>
      </v-row>

      <v-flex xs12 class="text-center">
        <a
          href="https://api.whatsapp.com/send/?phone=+5548999823931&text&type=phone_number&app_absent=0&text=Olá Espaço Mossoo..."
          target="_blank"
          style="text-decoration: none; color: inherit"
        >
          <v-icon color="#34af23" style="vertical-align: middle; margin-right: 6px; font-size: 28px; position: relative; top: -3px">mdi-whatsapp</v-icon>
          <span :class="$vuetify.breakpoint.smAndDown ? 'p16' : 'p20'">Dúvidas? Entre em contato conosco.</span>
        </a>
      </v-flex>

      <v-flex xs12 :style="`height: ${$vuetify.breakpoint.xs ? '200px' : '100px'};`">&nbsp;</v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    urlPrivado() {
      return process.env.VUE_APP_URL_PRIVADO;
    }
  }
};
</script>
